import { useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid2 as Grid,
  TextField,
  useTheme,
} from '@mui/material'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown'
import Colors from '../../../utils/colors.json'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

interface Answer {
  [key: string]: {
    [key: string]: string
  }
}

const styles = (theme: any) => ({
  actionBtn: {
    borderRadius: '20px',
    textTransform: 'capitalize',
    minWidth: '180px',
    background: theme.customColors.button,
  },
  actionBtnBack: {
    borderRadius: '20px',
    textTransform: 'capitalize',
    minWidth: '180px',
    background: theme.customColors.btnBlack,
  },
  formTextField: {
    fontSize: '12px',
    fontWeight: 400,
    color: Colors.TEXT_COLOR_SECONDARY,
  },
  accordion: {
    background: Colors.QUESTIONS_BG,
  },

  accordionOpen: {
    background: theme.palette.primary.main,
    color: Colors.WHITE,
    borderRadius: '20px',
  },
  subAccordion: {
    background: Colors.WHITE_BACKGROUND,
  },
  subAccordionOpen: {
    backgroundColor: '#EACFE8',
  },
  questionTextUnselected: {
    fontWeight: 500,
    fontSize: '14px',
    color: theme.customColors.textColorMain,
  },
  questionTextSelected: {
    color: Colors.TEXT_SELECTED,
  },
  subLabelMember: {
    // fontWeight: 500,
    fontWeight: 'bold',
    fontSize: '12px',
    lineHeight: '14.4px',
    color: Colors.TEXT_COLOR_MAIN,
  },
  subLabelQuestion: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14.4px',
    color: theme.customColors.textColorSecondary,
  },
  formCheckBoxLabel: {
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '16.8px',
    color: theme.customColors.textColorMain,
  },
  formCheckBox: {
    background: Colors.BG_BOX,
    borderRadius: '20px',
    paddingLeft: 2,
    paddingRight: 10,
  },
  memberName: {
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '16.8px',
    color: Colors.WHITE,
    background: Colors.FIELD_BG,
    borderRadius: '20px',
  },
  compnentBg: {
    background: Colors.WHITE_BACKGROUND,
    borderRadius: '20px',
  },
})

const QuestionComponentOne = ({
  members,
  question,
  subquestion,
  answers,
  handleMemberChange,
  handleAnswerChange,
}: any) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const findMemberName = (memberId: string | number) => {
    const filteredMember = members?.filter(
      (item: { id: string | number }) => item?.id === Number(memberId)
    )
    return filteredMember?.[0]?.name
  }

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={4}
      p={3}
      className={classes?.compnentBg}
    >
      <Grid container direction={'column'} spacing={1}>
        <Typography className={classes?.subLabelMember}>
          Select Members
        </Typography>
        <Box display={'flex'} flexDirection={'row'} gap={2}>
          {members?.map((member: any, index: number) => (
            <FormControlLabel
              className={classes?.formCheckBox}
              key={index}
              control={<Checkbox size='small' />}
              label={
                <Typography className={classes?.formCheckBoxLabel}>
                  {member?.name}
                </Typography>
              }
              checked={Object.prototype.hasOwnProperty.call(
                answers?.[member?.id] ?? {},
                question
              )}
              onChange={(e, checked) =>
                handleMemberChange(checked, member?.id, question)
              }
            />
          ))}
        </Box>
      </Grid>

      <Box display={'flex'} flexDirection={'column'} gap={3}>
        {Object.keys(answers || {}).map((key: string, index: number) => {
          // const item = answers[key]
          return (
            <>
              {Object.prototype.hasOwnProperty.call(
                answers?.[key] ?? {},
                question
              ) &&
                question !== 'diabetesTypeOne' && (
                  <Grid
                    container
                    direction={'row'}
                    spacing={2}
                    size={{ xs: 12 }}
                  >
                    <Grid
                      container
                      direction={'column'}
                      size={{ xs: 2, sm: 12, lg: 2, md: 4, xl: 1 }}
                      spacing={1}
                    >
                      <Typography className={classes?.subLabelQuestion}>
                        Member Name
                      </Typography>
                      <Typography
                        className={classes?.memberName}
                        p={1}
                        width={'fit-content'}
                      >
                        {findMemberName(key)}
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      spacing={3}
                      size={
                        subquestion
                          ? { xs: 5, sm: 6, lg: 5, md: 4, xl: 5 }
                          : { xs: 3, sm: 3, lg: 3, md: 4, xl: 3 }
                      }
                    >
                      <Grid
                        container
                        direction={'column'}
                        size={{ xs: 12 }}
                        spacing={1}
                        key={index}
                      >
                        <Typography className={classes?.subLabelQuestion}>
                          Month & Year of diagnosis
                        </Typography>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            views={['month', 'year']}
                            // label='Controlled picker'
                            value={answers?.[key]?.[question]}
                            onChange={(newValue) =>
                              handleAnswerChange(
                                { target: { name: question, value: newValue } },
                                key
                              )
                            }
                            slotProps={{
                              textField: {
                                size: 'small',
                                placeholder: 'Existing Since (MM/YYYY)',
                                sx: {
                                  '& .MuiInputBase-input': {
                                    fontSize: '14px', // Class not applying
                                    minWidth: '220px',
                                  },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                    {subquestion && (
                      <Grid
                        container
                        spacing={3}
                        size={{ xs: 5, sm: 6, lg: 5, md: 4, xl: 5 }}
                      >
                        <Grid
                          container
                          direction={'column'}
                          size={{ xs: 8 }}
                          spacing={1}
                          key={index}
                        >
                          <Typography className={classes?.subLabelQuestion}>
                            Description
                          </Typography>
                          <TextField
                            multiline
                            size='small'
                            name={subquestion}
                            value={answers?.[key]?.[subquestion]}
                            onChange={(e: any) => handleAnswerChange(e, key)}
                            slotProps={{
                              input: {
                                className: classes?.formTextField,
                              },
                            }}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                )}
            </>
          )
        })}
      </Box>
    </Box>
  )
}

const QuestionComponentThree = ({
  members,
  question,
  answers,
  handleMemberChange,
  handleAnswerChange,
}: any) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const findMemberName = (memberId: string | number) => {
    const filteredMember = members?.filter(
      (item: { id: string | number }) => item?.id === Number(memberId)
    )
    return filteredMember?.[0]?.name
  }

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={4}
      width={'100%'}
      p={3}
      className={classes?.compnentBg}
    >
      <Grid container direction={'column'} spacing={1}>
        <Typography className={classes?.subLabelMember}>
          Select Members
        </Typography>
        <Box display={'flex'} flexDirection={'row'} gap={2}>
          {members?.map((member: any, index: number) => (
            <FormControlLabel
              key={index}
              className={classes?.formCheckBox}
              control={<Checkbox size='small' />}
              label={
                <Typography className={classes?.formCheckBoxLabel}>
                  {member?.name}
                </Typography>
              }
              checked={Object.prototype.hasOwnProperty.call(
                answers?.[member?.id] ?? {},
                question
              )}
              onChange={(e, checked) =>
                handleMemberChange(checked, member?.id, question)
              }
            />
          ))}
        </Box>
      </Grid>

      <Box display={'flex'} flexDirection={'column'} gap={3}>
        {Object.keys(answers || {}).map((key: string, index: number) => {
          // const item = answers[key]
          return (
            <>
              {Object.prototype.hasOwnProperty.call(
                answers?.[key] ?? {},
                question
              ) && (
                <Grid container direction={'row'} spacing={2} size={{ xs: 12 }}>
                  <Grid
                    container
                    direction={'column'}
                    size={{ xs: 2, sm: 12, lg: 2, md: 4, xl: 1 }}
                    spacing={1}
                  >
                    <Typography className={classes?.subLabelQuestion}>
                      Member Name
                    </Typography>
                    <Typography
                      className={classes?.memberName}
                      p={1}
                      width={'fit-content'}
                    >
                      {findMemberName(key)}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    size={{ xs: 8, sm: 12, lg: 8, md: 8, xl: 10 }}
                  >
                    <Grid
                      container
                      direction={'column'}
                      size={{ xs: 12 }}
                      spacing={1}
                      key={index}
                    >
                      <Typography className={classes?.subLabelQuestion}>
                        Description
                      </Typography>

                      <TextField
                        multiline
                        size='small'
                        name={question}
                        value={answers?.[key]?.[question]}
                        onChange={(e: any) => handleAnswerChange(e, key)}
                        slotProps={{
                          input: {
                            className: classes?.formTextField,
                          },
                        }}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </>
          )
        })}
      </Box>
    </Box>
  )
}

const MedicalQuestions = ({
  activeStep,
  setActiveStep,
}: {
  activeStep: number
  setActiveStep: (activeStep: number) => void
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [answers, setAnswers] = useState<any>({})
  // eslint-disable-next-line
  const [members, setMembers] = useState([
    {
      name: 'Vinaya Sree',
      id: 1234553,
    },
    {
      name: 'Sravan',
      id: 1234554,
    },
    {
      name: 'Rama Raju',
      id: 1234555,
    },
    {
      name: 'Vinay',
      id: 1234559,
    },
  ])
  const [expanded, setExpanded] = useState<number | null>(null)
  const [subAccordionexpanded, setSubAccordionexpanded] = useState<
    number | null
  >(null)

  const handleAccordionChange =
    (index: number) => (event: React.ChangeEvent<any>, isExpanded: boolean) => {
      setExpanded(isExpanded ? index : null)
    }

  const handleSubAccordionChange =
    (index: number) => (event: React.ChangeEvent<any>, isExpanded: boolean) => {
      setSubAccordionexpanded(isExpanded ? index : null)
    }

  const handleMemberChange = (checked: boolean, id: any, question: string) => {
    setAnswers((prev: any) => {
      const updatedAnswers = { ...prev }

      if (checked) {
        // Set the question key to an empty string if checked is true
        updatedAnswers[id] = {
          ...updatedAnswers[id],
          [question]: null,
        }
      } else {
        // Remove the question key if checked is false
        // eslint-disable-next-line
        const { [question]: removed, ...rest } = updatedAnswers[id]
        updatedAnswers[id] = rest
      }

      return updatedAnswers
    })
  }

  const handleAnswerChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const { name, value } = e.target

    setAnswers((prev: Answer) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [name]: value,
      },
    }))
  }

  const medicalQuestionSections = [
    {
      title: 'History of pre-existing diseases',

      defaultOpen: false,

      questions: [
        {
          label: 'Diabetes Type 2, Diabetes on Medicine',

          value: 'diabetesTypeTwoDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'diabetesTypeTwoDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Diabetes Mellitus type 1 or Diabetes on insulin or Diabetes associated with blindness or chronic foot ulcer',

          value: 'diabetesTypeOne',

          component: (
            <QuestionComponentOne
              members={members}
              question={'diabetesTypeOne'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label: 'Hypertension / High Blood Pressure',

          value: 'highBloodPressureDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'highBloodPressureDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Any Respiratory disease / Disease of Lungs, Pleura and airway (including but not limited to Asthma / Tuberculosis / Pleural effusion / Bronchitis / Emphysema)',

          value: 'respiratoryDiseaseDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'respiratoryDiseaseDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label: 'HIV/ AIDS/ STD',

          value: 'hivOrAidsOrStdDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'hivOrAidsOrStdDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Liver disease (including but not limited to Cirrhosis) or any other digestive track disorder (disorders of esophagus or stomach or intestine or any other)',

          value: 'liverDiseaseDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'liverDiseaseDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label: 'Pancreatitis, Hepatitis B or C, Wilson’s disease Cancer?',

          value: 'pancreatitisDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'pancreatitisDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Any cardiovascular/Heart Disease (including but not limited to Coronary artery disease, Rheumatic heart disease, Heart Attack, Myocardial infarction, Heart failure, Bypass Grafting, CABG, Angioplasty, Heart valve diseases, Pacemaker implantation)',

          value: 'cardioVascularDiseaseDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'cardioVascularDiseaseDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Any disorders of Blood and/or Immunity (including but not limited to bleeding or clotting disorders)',

          value: 'bloodDisorderDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'bloodDisorderDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Rheumatoid Arthritis, Crohn’s disease, Ulcerative Colitis, Systemic Lupus Erythematosus',

          value: 'rheumatoidArthritisDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'rheumatoidArthritisDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label: 'Any Kidney/Urinary tract/Reproductive organ Disease',

          value: 'anyKidneyDiseaseDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'anyKidneyDiseaseDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Any Neuromuscular (muscles or nervous system) disorder or Psychiatric disorders (including but not limited to mental illness)Psychiatric disorders (including but not limited to Motor Neuron Disease, Muscular dystrophies, Epilepsy, Paralysis, Parkinsonism, multiple sclerosis, stroke)',

          value: 'neuromuscularDisorderDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'neuromuscularDisorderDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label: 'Congenital Disorder',

          value: 'congenitalDisorderDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'congenitalDisorderDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label: 'Any other diseases or ailments not mentioned above',

          value: 'anyOtherDiseaseDiagnosedDate',

          component: (
            <QuestionComponentOne
              members={members}
              question={'anyOtherDiseaseDiagnosedDate'}
              subquestion={'anyOtherDiseaseDescription'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Any disorders of the endocrine system (including but not limited to Pituitary / Parathyroid / adrenal gland disorders)Has any of the Proposed to be Insured consulted/taken treatment or recommended to take investigations/medication/surgery other than for childbirth/minor injuries?',

          component: (
            <QuestionComponentOne
              members={members}
              question={'endocrineSystemDisorderDiagnosedDate'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Has any of the Proposed to be Insured consulted/taken treatment or recommended to take investigations/medication/surgery other than for childbirth/minor injuries?',

          value: 'surgeryHistoryExistingSince',

          component: (
            <QuestionComponentOne
              members={members}
              question={'surgeryHistoryExistingSince'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },

        {
          label:
            'Has any of the Proposed to be Insured been hospitalized or has been under any prolonged treatment for any illness/injury or has undergone surgery other than for childbirth/minor injuries?',

          value: 'surgeryHistoryExistingSince',

          component: (
            <QuestionComponentOne
              members={members}
              question={'surgeryHistoryExistingSince'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },
      ],
    },

    {
      title: 'Substance Use and Lifestyle History',

      defaultOpen: false,
    },

    {
      title: 'Hospitalization History',

      defaultOpen: false,

      questions: [
        {
          label:
            'Have any of the above mentioned person(s) to be insured been hospitalized for any illness/ injury during the last 48 months?',

          value: 'hospitalizationHistoryDescription',

          component: (
            <QuestionComponentThree
              members={members}
              question={'hospitalizationHistoryDescription'}
              answers={answers}
              handleMemberChange={handleMemberChange}
              handleAnswerChange={handleAnswerChange}
            />
          ),
        },
      ],
    },
  ]

  return (
    <Grid container direction={'column'} spacing={4} pl={2}>
      <Grid size={{ xs: 12 }}>
        {medicalQuestionSections?.map((item, index) => (
          <Accordion
            key={index}
            expanded={expanded === index}
            onChange={handleAccordionChange(index)}
            className={classes?.accordion}
          >
            <AccordionSummary
              expandIcon={
                <ExpandCircleDownIcon
                  className={expanded === index ? classes?.accordionOpen : ''}
                />
              }
              aria-controls='panel1-content'
              id='panel1-header'
              className={expanded === index ? classes?.accordionOpen : ''}
            >
              <Typography>{item?.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {item?.questions?.map((question, index) => (
                <Accordion
                  key={index}
                  className={
                    subAccordionexpanded === index
                      ? classes?.subAccordionOpen
                      : classes?.subAccordion
                  }
                  expanded={subAccordionexpanded === index}
                  onChange={handleSubAccordionChange(index)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandCircleDownIcon />}
                    aria-controls='panel1-content'
                    id='panel1-header'
                  >
                    <Typography
                      className={
                        subAccordionexpanded === index
                          ? classes?.questionTextSelected
                          : classes?.questionTextUnselected
                      }
                    >
                      {question?.label}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>{question?.component}</AccordionDetails>
                </Accordion>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>

      <Grid
        size={{ xs: 12 }}
        textAlign={'center'}
        display={'flex'}
        justifyContent={'space-around'}
        mb={1}
      >
        <Button
          variant='contained'
          // color='primary'
          className={classes?.actionBtnBack}
          onClick={() => setActiveStep(activeStep - 1)}
        >
          Back
        </Button>
        <Button
          variant='contained'
          // color='primary'
          className={classes?.actionBtn}
          onClick={() => setActiveStep(activeStep + 1)}
        >
          Proceed To Nominee
        </Button>
      </Grid>
    </Grid>
  )
}

export default MedicalQuestions
